import { render, staticRenderFns } from "./score-suzhou.vue?vue&type=template&id=38ba6cb0&scoped=true"
import script from "./score-suzhou.vue?vue&type=script&lang=js"
export * from "./score-suzhou.vue?vue&type=script&lang=js"
import style0 from "./score-suzhou.vue?vue&type=style&index=0&id=38ba6cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ba6cb0",
  null
  
)

export default component.exports